import Swiper from "./plugins/swiper-bundle.esm.browser.min.js";
import MetaMap from "./plugins/map/metaMap.v2.js";

import "./meta-settings.js";
import { MetaSwiper } from "./meta-settings.js";
import { CountUp } from "./plugins/countUp.js";

let safari12 = navigator.sayswho == "Safari 12";
let safari13 = navigator.sayswho == "Safari 13";
let safari14 = navigator.sayswho == "Safari 14";

let userAgent = navigator.userAgent.toLowerCase();
let iphone = /iphone/gi.test(userAgent);
let iphoneIOs13 = /iphone.*version\/13.*safari/gi.test(userAgent);
let ipadIOs13 = /mac.*version\/13.*safari/gi.test(navigator.userAgent.toLowerCase());
let ipad = /ipad/gi.test(userAgent);
let isTouch = (("ontouchstart" in window) || (navigator.msMaxTouchPoints > 0));

safari12 ? $("body").addClass("safari-12") : "";
safari13 ? $("body").addClass("safari-13") : "";
safari14 ? $("body").addClass("safari-14") : "";


AOS.init({
  duration: 800,
  useClassNames: true,
  once: true,
});


const header = document.getElementsByClassName(`header`)[0];
// Header scroll
const scrollContainer = () => {
  return document.documentElement || document.body;
};
if (header) {
  if (header.classList.contains("fixed")) {
    document.addEventListener("scroll", () => {
      if (scrollContainer().scrollTop > 0) {
        header.classList.add("scrolled");
      } else if (scrollContainer().scrollTop == 0) {
        header.classList.remove("scrolled");
      }
    });
  }
}


// menu handlers

///check mobile menu show/hide condition
const mobileMenuStartPoint = +getComputedStyle(document.documentElement).getPropertyValue("--mobile-menu-start-point");
let isMobileMenuEnable = $(window).outerWidth() <= mobileMenuStartPoint || $(".header-mobile").length;

//fix mobile menu height because of bottom system navigation panel
if (isMobileMenuEnable) {
  let navbar = document.querySelector(".navbar-nav");
  if (navbar) {
    let vh = window.innerHeight * 0.01;
    navbar.style.setProperty("--vh", `${vh}px`);
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      navbar.style.setProperty("--vh", `${vh}px`);
    });
  }
}

if (isMobileMenuEnable || isTouch) {
  let navLinks = $(".menu-link");
  navLinks.each((idx, link) => {
    $(link).on("click", function(e) {
      let $thisLink = $(this);
      if ($(this).parent().hasClass("dropdown") && !$(this).parent().hasClass("active")) {
        e.preventDefault();
        let activeMenuItem = $(".active.dropdown");
        activeMenuItem.find(".dropdown-menu").slideUp(300, function() {
          activeMenuItem.removeClass("active");
        });
        $(this).parent().addClass("active");
        $(this).next(".dropdown-menu").slideDown();
      }
    });
    $(link).on("click", ".icon-chewron-down", function(e) {

      if ($(this).closest(".dropdown").hasClass("active")) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest(".dropdown").removeClass("active");
        $(this).parent().next(".dropdown-menu").slideUp();
      }
    });
  });
}


$(".dropdown-toggle").click(function(e) {
  if (isMobileMenuEnable) {
    //close all opened sub menu
    $(".menu-item.dropdown.active .dropdown-menu").slideUp({
      complete: function() {
        $(this).closest(".dropdown").removeClass("active");
      },
    });

    //open current submenu
    $(this).closest(".menu-item.dropdown").toggleClass("active");
    if ($(this).closest(".menu-item.dropdown").hasClass("active")) {
      e.preventDefault();
      $(this).next(".dropdown-menu").slideDown();
    }
  }
});

// toggle menu handler
function menuToggle() {
  $(".menu-toggle .plate").toggleClass("active");
  $(".navbar-nav").toggleClass("active");
  $(".navbar-nav").css("transform", "translateX(0)");
  setTimeout(() => {
    $(".navbar-nav").css("transform", "");
  }, 800);
  $(".header-close-wrapper").toggleClass("active");
  // LockScroll when burger open and enable when closed and enable scroll on menu
  scrollLock.getScrollState()
    ? scrollLock.disablePageScroll(document.querySelector(".navbar-nav .menu"))
    : scrollLock.enablePageScroll();
}

//menu update function
function updateMenu() {
  isMobileMenuEnable =
    $(window).outerWidth() <= mobileMenuStartPoint ||
    $(".mobile-header").length;
  if (!isMobileMenuEnable) {
    $(".dropdown-menu").css("display", "");
    $(".header-close-wrapper").removeClass("active");
    $(".menu-item.active").removeClass("active");
    $(".navbar-nav").removeClass("active");
    $(".menu-toggle .plate").removeClass("active");
    // LockScroll when burger open and enable when closed
    scrollLock.enablePageScroll();
  }
}

$(window).on("resize orientationchange", updateMenu);
// end of toggle menu handler

$(".menu-toggle").click(menuToggle); //menu toggles
$(".header-close-wrapper").click(menuToggle); //menu toggles


var elements = document.querySelectorAll(".force-sticky");
Stickyfill.forceSticky();
Stickyfill.add(elements);

/*Tesla style menu start */
const navbar = document.querySelector(`.navbar .menu`);
if (navbar && !isMobileMenuEnable) {
  const navbarElements = navbar.querySelectorAll(`.menu-item`);
  const spanElement = navbar.querySelector(`.menu-item-slider`);
  const activeMenuElement = navbar.querySelector(`.menu-item.active`);

  function backgroundMenuPositionFunc(targetElement, flagMouseEnter) {
    const navbarPosition = navbar.getBoundingClientRect();
    const elementPosition = targetElement.getBoundingClientRect();
    let spanPositionLeftStart = elementPosition.left - navbarPosition.left;
    let spanWidthStart = elementPosition.width;

    if (flagMouseEnter) {
      spanElement.style.setProperty(
        "--span-transition",
        `0.5s cubic-bezier(0.75, 0, 0, 1), border-radius 0.5s ease`,
      );
    } else {
      spanElement.style.setProperty(
        "--span-transition",
        `opacity 0.5s ease, visibility 0s 0s, border-radius 0.5s ease`,
      );
    }
    spanElement.style.setProperty("--width-span", `${spanWidthStart}px`);
    spanElement.style.setProperty(
      "--left-position-span",
      `${spanPositionLeftStart}px`,
    );
  }

  if (activeMenuElement) {
    backgroundMenuPositionFunc(activeMenuElement, true);
    spanElement.classList.add("active");
    navbarElements.forEach((elem) => {
      elem.addEventListener("mouseenter", function(e) {
        backgroundMenuPositionFunc(e.target, true);
      });

      navbar.addEventListener("mouseleave", function(e) {
        backgroundMenuPositionFunc(activeMenuElement, true);
      });
    });
  } else {
    let flagMouseEnter = false;
    navbarElements.forEach((elem) => {
      elem.addEventListener("mouseenter", function(e) {
        backgroundMenuPositionFunc(e.target, flagMouseEnter);
        spanElement.classList.add("active");

        flagMouseEnter = true;
      });
    });
    navbar.addEventListener("mouseleave", function(e) {
      spanElement.classList.remove("active");
      flagMouseEnter = false;
      spanElement.style.setProperty(
        "--span-transition",
        `opacity 0.5s ease, visibility 0s 0.5s, border-radius 0.5s ease`,
      );
    });
  }
}
/*Tesla style menu end */
$(".select2-item").each((ind, el) => {
  $(el).select2();
});


function setCountUp(counts, swiper) {
  if (counts.length) {
    if (!counts[0].hasAttribute("id")) {
      const defaultOptions = {
        separator: "",
        enableScrollSpy: true,
        scrollSpyRunOnce: true,
      };

      let idNumber = 1;

      counts.forEach((count) => {
        const id = `count-up-${idNumber}`,
          value = parseFloat(count.innerHTML);

        let optionsFromDataAttr = $(count).data();
        for (const key in optionsFromDataAttr) {
          if (optionsFromDataAttr[key] === "") {
            optionsFromDataAttr[key] = true;
          }
        }

        count.id = id;

        let countUp = new CountUp(
          id,
          value,
          Object.assign(Object.assign({}, defaultOptions), optionsFromDataAttr),
        );
        idNumber++;
        if (safari12) {
          setTimeout(function() {
            if (swiper && window.innerHeight + window.scrollY > $(swiper).offset().top) {
              countUp.start();
            }
          }, 50);
        }
      });
    }

  }
}

let satsSwiperWr = document.querySelectorAll(".stats-swiper-wr");
satsSwiperWr.forEach(el => {
  if (el) {
    let swiperBlock = el.querySelector(".swiper");
    let nextEl = el.querySelector(".swiper-button-next");
    let prevEl = el.querySelector(".swiper-button-prev");
    let slidesCount = swiperBlock.querySelectorAll(".swiper-slide").length;
    const swiper = new Swiper(swiperBlock, {
      speed: 800,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      autoplay: {
        delay: 5000,
      },
      breakpoints: {
        280: {
          spaceBetween: 15,
          slidesPerView: 1.6,
          centeredSlides: true,
          loop: slidesCount > 1,
        },
        450: {
          slidesPerView: 2,
          loop: slidesCount > 2,
          centeredSlides: false,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          loop: slidesCount > 3,
          spaceBetween: 30,
        },
      },
      on: {
        afterInit: function() {
          let counts = swiperBlock.querySelectorAll(".stat-card-counter .stats-count-up");

          if (counts.length) {
            setCountUp(counts, swiperBlock);
          }
        },
        breakpoint: function(swiper) {
          let breakpoint = this.currentBreakpoint;
          let loop = this.passedParams.breakpoints[breakpoint].loop;
          if (loop) {
            swiper.$el[0].querySelector(".swiper-wrapper").classList.remove("justify-center");
            this.loopCreate();
            nextEl.classList.remove("swiper-button-lock", "swiper-button-disabled");
            prevEl.classList.remove("swiper-button-lock", "swiper-button-disabled");

          } else {
            if (swiper.$el[0].querySelector(".swiper-slide-duplicate")) {
              swiper.$el[0].querySelector(".swiper-wrapper").classList.remove("justify-center");
            } else {
              swiper.$el[0].querySelector(".swiper-wrapper").classList.add("justify-center");
            }
            this.loopDestroy();
          }
        },
      },
    });
  }
});

let fdSwiperWr = document.querySelectorAll(".fd-swiper-wr");
fdSwiperWr.forEach(el => {
  if (el) {
    let swiperBlock = el.querySelector(".swiper");
    let slidesCount = swiperBlock.querySelectorAll(".swiper-slide").length;
    const swiper = new Swiper(swiperBlock, {
      slidesPerView: "auto",
      speed: 800,
      autoplay: {
        delay: 5000,
      },
      breakpoints: {
        200: {
          loop: slidesCount > 1,
        },
        500: {
          loop: slidesCount > 2,
        },
        750: {
          loop: slidesCount > 2,
        },
        1200: {
          loop: slidesCount > 4,
        },
        1800: {
          loop: slidesCount > 5,
        },
      },
    });
  }
});

let tsSwiperWr = document.querySelectorAll(".ts-swiper-wr");
tsSwiperWr.forEach(el => {
  if (el) {
    let swiperBlock = el.querySelector(".swiper");
    let nextEl = el.querySelector(".swiper-button-next");
    let prevEl = el.querySelector(".swiper-button-prev");
    let slidesCount = swiperBlock.querySelectorAll(".swiper-slide").length;
    const swiper = new Swiper(swiperBlock, {
      slidesPerView: "auto",
      spaceBetween: 40,
      speed: 800,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        200: {
          loop: slidesCount > 1,
          spaceBetween: 17.5,
        },
        860: {
          loop: slidesCount > 2,
          spaceBetween: 40,
        },
        1300: {
          loop: slidesCount > 3,
          spaceBetween: 40,
        },
        2000: {
          loop: slidesCount > 4,
          spaceBetween: 40,
        },
      },
    });
  }
});


let resultSwiperWr = document.querySelectorAll(".result-slider-box");
resultSwiperWr.forEach(el => {
  if (el) {
    let swiper = el.querySelector(".swiper");
    let nextEl = el.querySelector(".swiper-button-next");
    let prevEl = el.querySelector(".swiper-button-prev");
    let slidesCount = swiper.querySelectorAll(".swiper-slide").length;
    MetaSwiper(swiper, {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: "fade",
      speed: 800,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      autoplay: {
        delay: 5000,
      },
    });
  }
});


if (document.querySelector(".partners-slider")) {
  const swiperBlock = document.querySelector(".partners-slider");
  const swiper = new Swiper(swiperBlock, {
    slidesPerView: 2,
    spaceBetween: 20,
    speed: 800,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      568: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 48,
      },
    },
  });
}

function adaptiveReplaceFunc() {
  let adaptiveReplace = false;
  $(window).on("resize orientationchange", function() {
    if ($(window).width() <= 768 && !adaptiveReplace) {
      adaptiveReplace = true;
      let captionFooter = $(".contact-plug-caption-footer");
      captionFooter.addClass("js-replace-mb");
      $(".contact-plug-caption-wr").append(captionFooter);
    } else if ($(window).width() > 768 && adaptiveReplace) {
      adaptiveReplace = false;
      let captionFooter = $(".contact-plug-caption-footer");
      captionFooter.removeClass("js-replace-mb");
      $(".contact-plug-caption").append(captionFooter);
    }
  });
  $(window).trigger("resize");
}

adaptiveReplaceFunc();


let sectorsSwiperWr = document.querySelectorAll(".sectors-swiper-wr");
sectorsSwiperWr.forEach(el => {
  if (el) {
    let swiper = el.querySelector(".swiper");
    let nextEl = el.querySelector(".swiper-button-next");
    let prevEl = el.querySelector(".swiper-button-prev");
    let slidesCount = swiper.querySelectorAll(".swiper-slide").length;
    MetaSwiper(swiper, {
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 800,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  }
});

let teamSwiperWr = document.querySelectorAll(".team-swiper-wr");
teamSwiperWr.forEach(el => {
  if (el) {
    let swiper = el.querySelector(".swiper");
    let nextEl = el.querySelector(".swiper-button-next");
    let prevEl = el.querySelector(".swiper-button-prev");
    let slidesCount = swiper.querySelectorAll(".swiper-slide").length;
    MetaSwiper(swiper, {
      initialSlide: 0,
      slidesPerView: 4,
      spaceBetween: 16,
      speed: 800,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        280: {
          slidesPerView: 1,
          loop: slidesCount > 1,
        },
        450: {
          slidesPerView: 2,
          loop: slidesCount > 2,
        },
        768: {
          slidesPerView: 3,
          loop: slidesCount > 3,
        },
        1024: {
          slidesPerView: 4,
          loop: slidesCount > 4,
        },
      },
      on: {
        breakpoint: function() {
          let breakpoint = this.currentBreakpoint;
          let loop = this.passedParams.breakpoints[breakpoint].loop;
          if (loop) {
            this.loopCreate();
            nextEl.classList.remove("swiper-button-lock", "swiper-button-disabled");
            prevEl.classList.remove("swiper-button-lock", "swiper-button-disabled");
          } else {
            this.loopDestroy();
          }
        },
      },
    });
  }
});


function plyrVideoInit(selector, swiperT, parent, swiperV) {
  let playerArr = [];
  let videos = $(parent).find(`${selector}`);

  videos.each((ind, video) => {
    const player = new Plyr(video, {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "duration",
        "mute",
        "volume",
        "captions",
        "fullscreen",
      ],
    });
    playerArr.push(player);
    if (swiperT && swiperV) {
      player.on("play", (event) => {
        swiperV.autoplay.stop();
        swiperT.autoplay.stop();
      });
      player.on("pause", (event) => {
        swiperV.autoplay.start();
        swiperT.autoplay.start();
      });
    }

  });

  return playerArr;
}

plyrVideoInit(".plyr-video-hr");

let videoTsSwiperWr = document.querySelectorAll(".video-ts-swiper-wr");
videoTsSwiperWr.forEach(el => {
  if (el) {
    let playersArr = [];
    let videoSwiper = el.querySelector(".video-ts-swiper");
    let textSwiper = el.querySelector(".video-ts-text-swiper");
    let nextEl = el.querySelector(".swiper-button-next");
    let prevEl = el.querySelector(".swiper-button-prev");
    let swiperT = MetaSwiper(textSwiper, {
      slidesPerView: 1,
      speed: 800,
      effect: "fade",
      loop: false,
      autoHeight: true,
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });

    let swiperV = MetaSwiper(videoSwiper, {
      slidesPerView: 1,
      speed: 800,
      effect: "fade",
      loop: false,
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      on: {
        afterInit: (swiper) => {
          playersArr = plyrVideoInit(".plyr-video", swiperT, videoSwiper, swiper);
        },
        slideChange: () => {
          playersArr.forEach(player => player.pause());
        },
      },
    });
    swiperT.controller.control = swiperV;


    if ((!safari12 && !iphoneIOs13)) {
      if ((!ipadIOs13 && !isTouch)) {
        let options = {
          root: document,
          rootMargin: "0px",
          threshold: 1.0,
        };
        let cb = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              swiperV.autoplay.start();
              swiperT.autoplay.start();
            } else {
              swiperV.autoplay.stop();
              swiperT.autoplay.stop();
            }
          });
        };
        let observer = new IntersectionObserver(cb, options);
        observer.observe(textSwiper);
      }

    } else {
      window.addEventListener("scroll", function() {
        if ($(window).scrollTop() > $(textSwiper).offset().top - ($(window).height() * 0.93) &&
          $(window).scrollTop() < $(textSwiper).offset().top + $(textSwiper).height() - ($(window).height() * 0.25)
        ) {
          swiperV.autoplay.start();
          swiperT.autoplay.start();
        } else {
          swiperV.autoplay.stop();
          swiperT.autoplay.stop();
        }
      });
    }
  }

});

let accSwiperWr = document.querySelectorAll(".acc-swiper-wr");
accSwiperWr.forEach(el => {
  if (el) {
    let swiper = el.querySelector(".swiper");
    let slidesCount = swiper.querySelectorAll(".swiper-slide").length;
    let nextEl = el.querySelector(".swiper-button-next");
    let prevEl = el.querySelector(".swiper-button-prev");
    let metaSwiper = MetaSwiper(swiper, {
      slidesPerView: 5,
      spaceBetween: 16,
      speed: 800,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        320: {
          loop: slidesCount > 2,
          slidesPerView: 2,
        },
        450: {
          loop: slidesCount > 4,
          slidesPerView: 4,
        },
        768: {
          loop: slidesCount > 5,
          slidesPerView: 5,
        },

      },
      on: {
        breakpoint: function(swiper) {
          let breakpoint = this.currentBreakpoint;
          let loop = this.passedParams.breakpoints[breakpoint].loop;

          if (loop) {
            swiper.$el[0].querySelector(".swiper-wrapper").classList.remove("justify-center");
          } else {
            if (swiper.$el[0].querySelector(".swiper-slide-duplicate")) {
              swiper.$el[0].querySelector(".swiper-wrapper").classList.remove("justify-center");
            } else {
              swiper.$el[0].querySelector(".swiper-wrapper").classList.add("justify-center");
            }
          }
        },
      },
    });
  }
});


let valuesSwiperWr = document.querySelectorAll(".values-swiper-wr");
valuesSwiperWr.forEach(el => {
  if (el) {
    let swiper = el.querySelector(".swiper");
    let slidesCount = swiper.querySelectorAll(".swiper-slide").length;
    MetaSwiper(swiper, {
      slidesPerView: "auto",
      spaceBetween: 15,
      speed: 800,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        320: {
          loop: slidesCount > 2,
        },
        450: {
          loop: slidesCount > 4,
        },
        650: {
          loop: slidesCount > 5,
        },
        768: {
          loop: slidesCount > 5,
          spaceBetween: 25,
        },
        1024: {
          oop: slidesCount > 5,
          spaceBetween: 40,
        },
      },
      on: {
        breakpoint: function() {
          let breakpoint = this.currentBreakpoint;
          let loop = this.passedParams.breakpoints[breakpoint].loop;
          if (!loop) {
            swiper.querySelector(".swiper-wrapper").classList.add("justify-center");
          } else {
            swiper.querySelector(".swiper-wrapper").classList.remove("justify-center");
          }
        },
      },
    });
  }
});

if (document.getElementById("map")) {
  const map = document.getElementById("map");
  const branchList = document.getElementById("branches-swiper");
  const allPinsArr = [...document.querySelectorAll(".markers .marker")];
  let branchesSwiperWr = document.querySelectorAll(".branches-swiper-wr");
  const branchCards = [...branchesSwiperWr[0].querySelectorAll(".swiper-slide")];
  let branchesSwiper;


  $("body").on("click", ".branch-card-close", hideCardPopup);
  $("body").on("click", ".swiper-button", hideCardPopup);
  $("body").on("click", function(e) {
    let target = $(e.target);
    if (!target.closest(".branch-card.branch-card-popup").length && !target.closest("#map .marker").length) {
      hideCardPopup();
    }
  });


  function hideCardPopup() {
    if (window.innerWidth >= 769) {
      $(".marker").removeClass("active");
      map.classList.remove("active");
      branchList.classList.remove("active");
      $(".branch-caption-section").removeClass("active");
      $(".branch-card.branch-card-popup").removeClass("active");
      $(".branch-card.branch-card-popup").fadeOut({
        duration: 200,
        complete: () => {
          scrollLock.enablePageScroll();
        },
      });
    } else {
      $(".branches-swiper").removeClass("active");
      map.classList.remove("active");
      $(".branch-caption-section").removeClass("active");
    }
  }

  branchesSwiperWr.forEach(el => {
    if (el) {
      let swiper = el.querySelector(".swiper");
      let nextEl = el.querySelector(".swiper-button-next");
      let prevEl = el.querySelector(".swiper-button-prev");
      let slidesCount = swiper.querySelectorAll(".swiper-slide").length;
      let branchesSwiperInitialized = false;
      $(window).on("resize", function() {
        if (window.innerWidth < 769 && branchesSwiperInitialized === false) {
          branchesSwiperInitialized = true;
          branchesSwiper = MetaSwiper(swiper, {
            slidesPerView: 1,
            spaceBetween: 15,
            speed: 800,
            loop: false,
            navigation: {
              nextEl: nextEl,
              prevEl: prevEl,
            },
            breakpoints: {
              100: {
                slidesPerView: 1,
                spaceBetween: 25,
              },
              600: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
            },
            on: {
              sliderFirstMove: function() {
                swiper.classList.remove("active");
                map.classList.remove("active");
              },
            },
          });
        } else if (window.innerWidth >= 769 && branchesSwiperInitialized === true) {
          branchesSwiperInitialized = false;
          branchesSwiper.destroy(true, true);
          $(".branches-swiper").removeClass("active");
          $(".branches-swiper .swiper-slide").removeClass("active");
          map.classList.remove("active");
        }
      });
      $(window).trigger("resize");
    }
  });

  window.initMap = function initMap(markers) {
    try {
      const map2 = new MetaMap("#map", {
        countryFillColor: "#ededed",
        mapPath: site_url + "app/public/js/plugins/map/data/gb.geo.json",
        zoomedCountries: "GB",
        zoomEnable: false,
        markers: markers,
        on: {
          markerClick(pin, data) {
            if (window.innerWidth >= 769) {
              let id = data.id;
              let branchHtml = branchList.querySelector(`[data-id=${id}] .branch-card`).innerHTML;
              //branch.classList.add("active");
              $(".branch-card.branch-card-popup").stop(true, true).fadeIn({
                duration: 200,
                start: function() {
                  $(this).html(`<div class="branch-card-close"><div class="icon-close"></div></div>` + branchHtml);
                },
                complete: function() {
                  $(this).addClass("active");
                },
              });
              branchList.classList.add("active");
              $(".branch-caption-section").addClass("active");
              $(".marker").removeClass("active");
              pin.classList.add("active");
              map.classList.add("active");
              if (scrollLock.getScrollState()) {
                scrollLock.disablePageScroll();
              }
            } else {
              let id = data.id;
              let newIdx = branchCards.findIndex(card => card.dataset.id === id);
              if (!branchCards[newIdx]) return;
              branchesSwiperWr[0].querySelector(".swiper").classList.add("active");
              branchCards[newIdx].classList.add("active");
              branchCards.forEach((card, index) => {
                if (index != newIdx) {
                  card.classList.remove("active");
                }
              });
              $(".marker").removeClass("active");
              map.classList.add("active");
              pin.classList.add("active");
              allPinsArr.forEach(el => {
                if (el != pin) el.classList.remove("active");
              });
              branchesSwiper.slideTo(newIdx);

            }
          },
        },
        markerStyle: {
          img: site_url + "app/public/images/pin.svg",
          width: 1,
          height: 1.2,
        },
      });
    } catch (e) {
      setTimeout(function() {
        initMap(branchMarkers);
      }, 500);
    }

  };
  setTimeout(function() {
    initMap(branchMarkers);
  }, 500);


}

/*slider */

const singleRangeSliderTooltip = () => {
  const singleRange = document.getElementsByClassName(
    "single-range-tooltip",
  )[0];
  if (singleRange) {
    const slider = singleRange.querySelector("#single-range-tooltip");
    const max = +slider.dataset.max;
    const min = +slider.dataset.min;
    const unit = slider.dataset?.unit || "Km";
    const step = +slider.dataset.step;
    const inputHidden = singleRange.querySelector(
      ".single-range-hidden-input",
    );
    const startValue = +inputHidden.value;

    // how many percentages
    const borderLimit = 8;
    const borderDiff = 40 / borderLimit;

    noUiSlider.create(slider, {
      start: [startValue],
      connect: "lower",
      tooltips: true,
      margin: 5,
      step: step,
      range: {
        min: min,
        max: max,
      },
    });

    const tooltip = slider.querySelector(".noUi-tooltip");
    const circle = slider.querySelector(".noUi-origin");
    const minLabel = slider.querySelector(".min-label");
    const maxLabel = slider.querySelector(".max-label");
    const openRadiusSlider = document.querySelector(".open-radius-slider span");
    minLabel.innerHTML = min + unit;
    maxLabel.innerHTML = max + "+" + unit;

    function returnTransform(element) {
      return element
        .replace(/[^0-9][^\d.]/g, "")
        .replace(")", "")
        .split(" ")
        .map((str) => {
          return Number(str);
        });
    }

    slider.noUiSlider.on("update", function(values) {
      let translate = returnTransform(circle.style.transform)[0];

      inputHidden.value = Math.round(values);

      if (translate <= -100 + borderLimit) {
        tooltip.style.transform = `translate(${
          -50 + Math.abs(translate + 100 - borderLimit) * borderDiff
        }%,100%)`;
      } else if (translate >= -borderLimit) {
        tooltip.style.transform = `translate(${
          -50 - Math.abs(translate + borderLimit) * borderDiff
        }%,100%)`;
      } else {
        tooltip.style.transform = "translate(-50%,100%)";
      }

      let labelMaxvalue = Math.round(values) == max ? Math.round(values) + "+" : Math.round(values);
      tooltip.textContent = labelMaxvalue.toLocaleString("en-GB") + unit;
      openRadiusSlider.textContent = labelMaxvalue.toLocaleString("en-GB") + unit;
    });
  }
};
singleRangeSliderTooltip();

/*hide slider range popup if click on different element? but not on it*/
function hideSliderRangePopup() {
  $(".open-radius-slider.active").removeClass("active");
  $(".single-range-container").fadeOut();
}

$("body").on("click", function(e) {
  let target = $(e.target);
  if (!target.closest(".single-range-container").length && !target.closest(".open-radius-slider.active").length) {
    hideSliderRangePopup();
  }
});
$(".single-range-container .icon-close").click(hideSliderRangePopup);

$(".open-radius-slider").click(function() {
  $(".single-range-container").fadeIn();
  $(this).toggleClass("active");
});

/* End of hide slider range popup if click on different element? but not on it*/

let leadershipSwiperWr = document.querySelectorAll(".leadership-swiper-wr");
leadershipSwiperWr.forEach(el => {
  if (el) {
    let swiperInstance;
    let swiper = el.querySelector(".swiper");
    let nextEl = el.querySelector(".swiper-button-next");
    let prevEl = el.querySelector(".swiper-button-prev");
    let slidesCount = swiper.querySelectorAll(".swiper-slide").length;
    let swiperInstanceInitialized = false;
    $(window).on("resize", function() {
      if (window.innerWidth < 992 && swiperInstanceInitialized === false) {
        swiperInstanceInitialized = true;
        swiperInstance = MetaSwiper(swiper, {
          slidesPerView: 1,
          spaceBetween: 15,
          speed: 800,
          loop: false,
          autoplay: {
            delay: 5000,
          },
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          breakpoints: {
            100: {
              slidesPerView: 1,
              spaceBetween: 25,
              loop: slidesCount > 1,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 15,
              loop: slidesCount > 2,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 15,
              loop: slidesCount > 3,
            },
          },
        });
      } else if (window.innerWidth >= 993 && swiperInstanceInitialized === true) {
        swiperInstanceInitialized = false;
        swiperInstance.destroy(true, true);
        nextEl.style.display = "none";
        prevEl.style.display = "none";
      }
      if (!swiperInstanceInitialized) {
        nextEl.style.display = "none";
        prevEl.style.display = "none";
      } else {
        nextEl.style.display = "";
        prevEl.style.display = "";
      }
    });

    $(window).trigger("resize");
  }
});

let keyPeopleSwiperWr = document.querySelectorAll(".key-people-swiper-wr");
keyPeopleSwiperWr.forEach(el => {
  if (el) {
    let swiperInstance;
    let swiper = el.querySelector(".swiper");
    let nextEl = el.querySelector(".swiper-button-next");
    let prevEl = el.querySelector(".swiper-button-prev");
    let slidesCount = swiper.querySelectorAll(".swiper-slide").length;
    let swiperInstanceInitialized = false;
    $(window).on("resize", function() {
      if (window.innerWidth < 992 && swiperInstanceInitialized === false) {
        swiperInstanceInitialized = true;
        swiperInstance = MetaSwiper(swiper, {
          slidesPerView: 1,
          spaceBetween: 15,
          speed: 800,
          loop: false,
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          autoplay: {
            delay: 5000,
          },
          breakpoints: {
            100: {
              slidesPerView: 1,
              spaceBetween: 25,
              loop: slidesCount > 1,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 15,
              loop: slidesCount > 2,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 15,
              loop: slidesCount > 3,
            },
          },
        });
      } else if (window.innerWidth >= 993 && swiperInstanceInitialized === true) {
        swiperInstanceInitialized = false;
        swiperInstance.destroy(true, true);
        nextEl.style.display = "none";
        prevEl.style.display = "none";
      }
      if (!swiperInstanceInitialized) {
        nextEl.style.display = "none";
        prevEl.style.display = "none";
      } else {
        nextEl.style.display = "";
        prevEl.style.display = "";
      }
    });

    $(window).trigger("resize");
  }
});

function setAnimationMultiplyDelay(element, startDelay, defaultDelayStep, breakDelay) {
  let targetArr = $(`${element}`);
  let delay = startDelay ? startDelay : 0;
  let delayStep = defaultDelayStep ? defaultDelayStep : 0;
  let counter = 0;
  if (!delayStep) return;
  targetArr.each((idx, el) => {
    if (el) {
      $(el).attr("data-aos-delay", delay);
      delay += defaultDelayStep;
      if (breakDelay) {
        counter++;
        if (counter === breakDelay) {
          delay = 0;
          counter = 0;
        }
      }
    }
  });
}

setAnimationMultiplyDelay(".leadership-swiper:not(\".swiper-initialized\") .teammate-card", 0, 150, 3);
setAnimationMultiplyDelay(".key-people-swiper:not(\".swiper-initialized\") .teammate-card", 0, 150, 3);
setAnimationMultiplyDelay(".sector-list .sectors-card", 0, 150, 4);
setAnimationMultiplyDelay(".branches-swiper .swiper-slide", 0, 100, 2);

window.initCardTitle = function initCardTitle() {
  let JobcardTitles = document.querySelectorAll(".job-card-title");
  if (JobcardTitles) {
    /* Moves to a new line after the character / */
    JobcardTitles.forEach((el, idx) => {
      let text = el.innerText.split("");
      let newText = [];
      text.forEach(letter => {
        if (letter == "/") {
          newText.push(`${letter} <br>`);
        } else {
          newText.push(letter);
        }
      });
      el.classList.add("js-edited");
      el.innerHTML = newText.join("");
    });
  }
};
initCardTitle();
let newsFilters = document.querySelectorAll(".news-filters-item");
console.log("p[p[p[p[");
if (newsFilters) {
  newsFilters.forEach((filter, idx) => {
    let currentIdx = idx;
    filter.addEventListener("click", function() {
      filter.classList.toggle("active");
      newsFilters.forEach((filter, idx) => {
        if (idx != currentIdx) {
          filter.classList.remove("active");
        }
      });
    });
  });
}

let columnSwiperWr = document.querySelectorAll(".column-swiper-wr");
columnSwiperWr.forEach(el => {
  if (el) {
    let swiperBlock = el.querySelector(".swiper");
    let nextEl = el.querySelector(".swiper-button-next");
    let prevEl = el.querySelector(".swiper-button-prev");
    let slidesCount = swiperBlock.querySelectorAll(".swiper-slide").length;
    const swiper = new Swiper(swiperBlock, {
      slidesPerView: 1,
      spaceBetween: 40,
      speed: 800,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        650: {
          slidesPerView: 2,
        },
        1100: {
          slidesPerView: 3,
        },
      },
    });
  }
});

let gallerySwiperWr = document.querySelectorAll(".gallery-swiper-wr");
gallerySwiperWr.forEach(el => {
  if (el) {
    let swiperEl = el.querySelector(".swiper");
    /* let nextEl = el.querySelector('.swiper-button-next')
     let prevEl = el.querySelector('.swiper-button-prev')*/
    let slidesCount = el.querySelectorAll(".swiper-slide").length;
    let swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: 15,
      speed: 800,
      threshold: 10,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      breakpoints: {
        1024: {
          spaceBetween: 30,
        },
      },
      /* navigation: {
           nextEl: nextEl,
           prevEl: prevEl,
       }*/
    });


  }

});

let landing = document.querySelector(".landing-page");
if (landing) {
  let pbSection = document.getElementsByClassName("pb-section")[0];
  console.log(pbSection);
  if (pbSection.classList.contains("pb-white")) {
    document.getElementById("site").classList.add("header-text-color-dark");
  }
  if (!pbSection.classList.contains("hero-section")) {
    pbSection.classList.add("pb-first");
  }
}

let closeScamPopup = document.querySelectorAll(".scams-popup-close");
let scamPopup = document.getElementById("scams-popup");

if (!localStorage.getItem("scamAlertAccepted")) {
  scamPopup.style.display = "flex";
}

function closeScampopup() {
  localStorage.setItem("scamAlertAccepted", true);
  scamPopup.style.display = "none";
  console.log("close");
}

closeScamPopup.forEach(el => {
  el.addEventListener("click", closeScampopup);
});
/*Nws popup init handlers*/

let nwsSection = document.querySelector('.news-section');
let nwPopup = document.querySelector('.nws-popup');

if(nwsSection){
  window.addEventListener('scroll', function(){
    if(!nwPopup.classList.contains('hide') && !nwPopup.classList.contains('active') ){
      let threshold = 0.4; //40% of screen height, point when popup shows on screen
      let checkPoint = this.scrollY + this.innerHeight - this.innerHeight * threshold;
      if(checkPoint > nwsSection.offsetTop + nwsSection.clientHeight){
        nwPopup.classList.add('active');
      }
    }
  })
}
window.closeNwsPopup = function closeNwsPopup(){
  nwPopup.classList.remove('active');
  nwPopup.classList.add('hide');
}


let phoneInputs = document.querySelectorAll('input[type="tel"]');
let phoneReg = /^[a-zA-Z]?$/;

phoneInputs.forEach(input=>{
    input.addEventListener('keydown', function(e){
        if(phoneReg.test(e.key)){
            e.preventDefault()
        }
    })
})




/*Nws popup init*/
